module.exports = __webpack_public_path__ + "img/pass_type_MultipleRide.5a637088.jpg";